import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';

const Answer = (props) => {
    const [viewStatus, setGridAnswer] = useState('1');
    const [disable, setDisable] = useState(false);
    useEffect(() => {
        const buttonElements = document.getElementsByClassName('MuiButton-root');
        Array.prototype.filter.call(buttonElements, function (buttonEl) {
            setGridAnswer('1');
            setDisable(false);
            buttonEl.style.opacity = viewStatus;
            buttonEl.disabled = disable;
            // console.log("1st_____ ", disable, props.nextId);
        });
    }, [props.nextId]);
    useEffect(() => {
        const buttonElements = document.getElementsByClassName('MuiButton-root');
        Array.prototype.filter.call(buttonElements, function (buttonEl) {
            buttonEl.style.opacity = viewStatus;
            buttonEl.disabled = disable;
            // console.log("update DISABLE ", disable);
        });
    }, [disable]);

    return (
        <Button 
            onClick={() => {
                if (!/^https/.test(props.nextId) && props.nextId !== 'contact') {
                    setGridAnswer('0.2');
                    setDisable(true);
                };
                props.select(props.content, props.nextId);
            }}
        >
            {props.content}
        </Button>
    );
}

export default Answer;